import React , {useState} from "react";
import ModalDialog from "react-bootstrap/ModalDialog";
import Draggable from "react-draggable";
import "../../styles/Modal.css";

export const DraggableModalDialog = (props) => {
  const [boundaries, setBoundaries] = useState(null);

  const modalBounds = () => {
    const appBody = document.querySelector("body");
    const appReact = appBody.getBoundingClientRect();
    setBoundaries({
      left: 0 - (document.querySelector('.modal-content').offsetWidth + 200),
      right: appReact.right - document.querySelector('.modal-content').clientWidth,
      bottom: appReact.bottom - document.querySelector('.modal-content').clientHeight + 200,
      top: 0 - document.querySelector('.modal-content').clientHeight,
    })
  }

    return (
      <Draggable
       handle=".modal-header, .modal-content"
       cancel="input, textarea, select, option,button,.react-select-container, .react-select__control,.form-control,.react-select__menu"
       onDrag={modalBounds}
       bounds = {boundaries}
       >
        <ModalDialog {...props}/>
      </Draggable>
    );
}